module.exports = __webpack_public_path__ + "images/application/no-matches-adfbd681.svg";